import { PlusCircleIcon } from '@heroicons/react/24/outline'
import classNames from 'classnames'
import React from 'react'
import { useDrop } from 'react-dnd'
import { checkRaceNames } from '../../../../utils/checkNames'
import { ManageNonPartisanChartState } from '../hooks/use-manage-chart-hook'
import ManageChartRaceItem from './manage-chart-race-item'

const ManageNonPartisanChartRaces: React.FC<{
  state: ManageNonPartisanChartState
  handleErrors: React.Dispatch<React.SetStateAction<{}>>
  errors: any
  candidatesNamesChecked: boolean
}> = ({ state, handleErrors, errors }) => {
  const {
    addNewRace,
    form: { formState, watch },
    races,
  } = state

  const watchRaces = watch('races')

  const [, drop] = useDrop(() => ({
    accept: 'CHART-RACE',
    drop: () => ({}),
    collect: () => ({}),
  }))

  return (
    <>
      <div className="mb-8 font-medium tracking-widest uppercase">
        Build Election Test Chart
      </div>
      <div ref={drop}>
        {watchRaces &&
          races.map((field: any, index: number) => (
            <div key={field.id}>
              <ManageChartRaceItem
                index={index}
                field={field}
                checkNames={checkRaceNames}
                errorsArr={errors}
                handleErrors={handleErrors}
                raceTypes={state.raceTypes}
                manageNonPartisanChartState={state}
              />
            </div>
          ))}
      </div>
      <button
        onClick={state.addNewRace}
        type="button"
        className={classNames(
          'border border-primary-blue border-opacity-50 bg-[#E6EBF5] w-full font-semibold py-12 flex justify-center items-center mb-8 text-primary-blue rounded-md',
          { 'border-red-500 focus:outline-red-500': formState.errors.races }
        )}
      >
        <PlusCircleIcon className="w-6 mr-2" />
        Add Another Race
      </button>
    </>
  )
}

export default ManageNonPartisanChartRaces
